import { defineStore } from 'pinia'
import { IProfileState } from './profile.types'
import { IProfile } from '@/types/data-objects/profile'
import ProfileAPI from '@/api/modules/profile.api'
import NotificationsAPI from '@/api/modules/notifications.api'

export const useProfileStore = defineStore('profile', {
  state: (): IProfileState => ({
    data: {
      id: null,
      name: '',
      accountRole: null,
      featureRole: null,
      photoUrl: '',
      fromWebex: false,
      listAccounts: [],
      sampleInternalProjectIDsForAccount: [],
      featureEnablement: null,
      isImpersonating: false,
    } as IProfile,
    notifications: [],
    isLoading: false,
    error: {
      code: 0,
      isError: false,
      message: '',
    },
  }),

  getters: {
    currentCompany(state) {
      return state.data.listAccounts.find(item => item.current === true)
    },
    isAdminOrOwner(state): boolean {
      return [2, 3].includes(state.data.accountRole)
    },
  },

  actions: {
    async profileFetch() {
      try {
        this.isLoading = !this.isLoading
        const resp = await ProfileAPI.get_Index()
        this.data = resp as IProfile
        return resp
      } finally {
        this.isLoading = !this.isLoading
      }
    },
    async profileMetricsFetch() {
      try {
        this.isLoading = !this.isLoading
        const resp = await ProfileAPI.get_Metrics()
        this.data.profileMetrics = resp
        return resp
      } finally {
        this.isLoading = !this.isLoading
      }
    },
    async notificationsFetch() {
      const resp = await NotificationsAPI.get_Listing()
      this.notifications = resp
      return resp
    },
  },
})
